import { render, staticRenderFns } from "./SimpleListItem.vue?vue&type=template&id=b3567a12"
import script from "./SimpleListItem.vue?vue&type=script&lang=js"
export * from "./SimpleListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports